import React, { useState } from 'react';
import useDisplayWidth from '../../hooks/useDisplayWidth';
import useMemoizedItems from '../../hooks/useMemoizedItems';
import useRefreshedData from '../../hooks/useRefreshedData';

const Marquee = ({ initialData }) => {
  const [isPaused, setIsPaused] = useState(false);
  const refreshedData = useRefreshedData(initialData);
  useDisplayWidth(refreshedData);
  const items = useMemoizedItems(refreshedData);

  return (
    <div className="relative w-full overflow-hidden bg-gradient-to-r from-primary via-primary/90 to-primary shadow-lg border-b-2 border-accent">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-primary/10" />

      <div
        className="relative"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className={`flex whitespace-nowrap animate-marquee py-2 ${isPaused ? 'marquee-paused' : 'marquee-running'}`}>
          {items}
        </div>
        <div className={`absolute top-0 flex whitespace-nowrap animate-marquee2 py-2 ${isPaused ? 'marquee-paused' : 'marquee-running'}`}>
          {items}
        </div>

        {isPaused && (
          <div className="absolute top-2 right-4 bg-card/90 backdrop-blur-sm border border-primary/20 rounded-full px-3 py-1 shadow-lg">
            <div className="flex items-center gap-2">
              <div className="flex gap-1">
                <div className="w-1 h-4 bg-primary rounded-full" />
                <div className="w-1 h-4 bg-primary rounded-full" />
              </div>
              <span className="text-xs font-medium text-primary">PAUSED</span>
            </div>
          </div>
        )}
      </div>

      <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-primary to-transparent pointer-events-none" />
      <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-primary to-transparent pointer-events-none" />
    </div>
  );
};

export default Marquee;
